<template>
  <v-theme-provider>
    <div>
      <base-img
        :src="require('@/assets/howellcare_logo_new.png')"
        contain
        max-width="300"
        min-height="100"
        width="100%"
      />

      <base-title
        size="text-body-1"
        space="4"
        title="HOWELLCARE INDUSTRIES SDN BHD (1313838-X)"
        weight="regular"
      />

      <base-body>
        Howellcare Industries based in Malaysia is a one-stop glove manufacturing service provider from design, fabrication, installation, commissioning and production of international standard nitrile gloves.
      </base-body>

      <base-btn
        class="mb-12"
        color="primary"
        outlined
        @click="fnGoToAbout"
      >
        More Info
      </base-btn>
    </div>
  </v-theme-provider>
</template>

<script>
  export default {
    name: 'BaseInfo',

    props: {
      title: String,
      dark: Boolean,
    },

    data: () => ({
      business: [
        {
          icon: 'mdi-map-marker-outline',
          title: 'Address',
          text: '8553 N. Beach St. Ste. 227<br>Fort Worth, Texas 76137',
        },
        {
          icon: 'mdi-cellphone',
          title: 'Phone',
          text: '01 (800) 433 744<br>01 (800) 433 633',
        },
        {
          icon: 'mdi-email',
          title: 'Email',
          text: 'john@vuetifyjs.com<br>heather@vuetifyjs.com',
        },
      ],
    }),
    methods: {
      fnGoToAbout () {
        this.$router.push('/about')
      },
    },
  }
</script>
